export default __webpack_public_path__ + "static/media/diamondconnect_headerlogo.f776d35e.png";